import useCcWebviewUtilsHelper from '@di-shared/features/common/useCcWebviewUtilsHelper';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {WebviewUtils} from '@shared/webviewUtils';

function useMileageAgreementNotice() {
  const {openConfirm, openAlert} = useCcWebviewUtilsHelper();
  const {t} = useInferableTranslation();

  async function openAgreementSuccessAlert() {
    return await openAlert({
      title: t('T30203'),
      message: t('T30204'),
    });
  }

  async function openAgreementFailDueToCompanyAlert() {
    return await openAlert({
      title: t('T30205'),
      message: t('T30206_$tel', {tel: import.meta.env.VITE_EMERGENCY_TEL_BRAND}),
    });
  }

  async function openAgreementFailDueToSeoulAlert() {
    return await openAlert({
      title: t('T30205'),
      message: t('T30227_$tel', {tel: import.meta.env.VITE_EMERGENCY_TEL_BRAND}),
    });
  }

  async function openMileageApprovalPendingAlert() {
    return await openAlert({
      title: t('T30225'),
      message: t('T30226'),
    });
  }

  async function openSeoulMileageSignUpInfoConfirm() {
    return await WebviewUtils.openCustomAlert({
      title: t('T30207'),
      message: t('T30208'),
      isVerticalButton: true,
      buttons: [
        {text: t('T30209'), style: 'PRIMARY', actionType: 'DEFAULT'},
        {text: t('T30210'), style: 'BASIC', actionType: 'CANCEL'},
      ],
    });
  }

  async function openVehicleRegistrationGuideConfirm() {
    return await openConfirm({
      title: t('T30211'),
      message: t('T30212'),
      okText: t('T30213'),
      cancelText: t('T30210'),
    });
  }

  async function openUnifiedMembershipTransitionConfirm() {
    return await openConfirm({
      title: t('T30214'),
      message: t('T30215'),
      okText: t('T30216'),
      cancelText: t('T30210'),
    });
  }

  async function openUnsupportedServiceAlert() {
    return await openAlert({
      title: t('T30217'),
      okText: t('T30224'),
      message:
        `[${t('T30218')}]\n` +
        `• ${t('T30219')}\n` +
        `• ${t('T30220')}\n` +
        `• ${t('T30221')}\n` +
        `• ${t('T30222')}\n\n` +
        `• ${t('T30223')}\n\n` +
        '(서울시 고객센터 : 02-120)',
    });
  }

  return {
    openAgreementSuccessAlert,
    openAgreementFailDueToCompanyAlert,
    openMileageApprovalPendingAlert,
    openAgreementFailDueToSeoulAlert,
    openSeoulMileageSignUpInfoConfirm,
    openVehicleRegistrationGuideConfirm,
    openUnifiedMembershipTransitionConfirm,
    openUnsupportedServiceAlert,
  };
}

export default useMileageAgreementNotice;
